import api from 'Application/api/api';

const confirmUploadedFilesVerificationForDistanceProcedure = (
    driverLicenseControlId,
    cancelToken = null,
) =>
    api.post(
        `/measures/vehicles/driver-licenses/controls/${driverLicenseControlId}/driver-license/distance-check/confirm-uploaded-files-verification`,
        {},
        {
            cancelToken,
        },
    );

export default confirmUploadedFilesVerificationForDistanceProcedure;
